import { render, staticRenderFns } from "./InstallmentPaymentTabs.vue?vue&type=template&id=02700ee4&"
import script from "./InstallmentPaymentTabs.vue?vue&type=script&lang=js&"
export * from "./InstallmentPaymentTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports